import { useSelector } from "react-redux";

export default function useCurrentUserId() {
    return useSelector(state => state.auth.userId);
}
